import script from "./InteractiveHistogram.vue?vue&type=script&setup=true&lang=js"
export * from "./InteractiveHistogram.vue?vue&type=script&setup=true&lang=js"

import "./InteractiveHistogram.vue?vue&type=style&index=0&id=7485968a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7485968a"]])

export default __exports__